import type { Route } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { AuthFailureGuard, AuthLogoutGuard } from '@evc/platform';
import type { ImportAsyncComponent } from '@shared/types/utils.type';

import { ResetPasswordRedirectGuard } from '@app/guards/reset-password-redirect.guard';

const importPageNotFoundComponent: ImportAsyncComponent = () =>
  import('@shared/components/page-not-found/page-not-found.component').then(
    (m) => m.PageNotFoundComponent,
  );

const importProfilePageComponent: ImportAsyncComponent = () =>
  import('./pages/profile/profile.component').then((m) => m.ProfilePageComponent);

const importSecurityPrivacyPageComponent: ImportAsyncComponent = () =>
  import('./pages/secu-privacy/secu-privacy.component').then((m) => m.SecurityPrivacyPageComponent);

// const importApplicationsPageComponent:ImportAsyncComponent = () => import(
//   './pages/applications/applications.component'
// ).then(m => m.ApplicationsPageComponent);

export const appRoutes: Route[] = [
  {
    path: 'logout',
    canActivate: [AuthLogoutGuard],
    loadComponent: importPageNotFoundComponent,
    data: { logout: true },
  },
  {
    path: 'auth-fail',
    canActivate: [AuthFailureGuard],
    loadComponent: importPageNotFoundComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: importProfilePageComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'security-privacy',
    loadComponent: importSecurityPrivacyPageComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'password-reset',
    loadComponent: importSecurityPrivacyPageComponent,
    canActivate: [ResetPasswordRedirectGuard],
  },
  // {
  //   path: 'applications',
  //   loadComponent: importApplicationsPageComponent,
  //   canActivate: [MsalGuard],
  // },
  {
    path: '**',
    loadComponent: importPageNotFoundComponent,
    canActivate: [MsalGuard],
  },
];
